const matchhoroscope = {
  // Header Section
  "kundli_matching_service": "ಕುಂಡಲಿ ಮ್ಯಾಚಿಂಗ್ ಸೇವೆ",
  "match_your": "ನಿಮ್ಮ",
  "horoscopes": "ಕುಂಡಲಿ",
  "for_perfect_union": "ಪರಿಪೂರ್ಣ ಮೈತ್ರಿಗಾಗಿ",
  "match_horoscope_description": "ಮೌಲಿಕ ವೇದ ಜ್ಯೋತಿಷ್ಯದ ಮೂಲಕ ನಿಮ್ಮ ಹೊಂದಾಣಿಕೆಯನ್ನು ಕಂಡುಹಿಡಿಯಿರಿ. ನಮ್ಮ ಸಮಗ್ರ ಕುಂಡಲಿ ಮ್ಯಾಚಿಂಗ್ 36 ಗುಣಗಳ ವಿಶ್ಲೇಷಣೆಯಿಂದ ದಾಂಪತ್ಯ ಸೌಹಾರ್ದತೆ ಮತ್ತು ಸಂಬಂಧದ ಯಶಸ್ಸನ್ನು ನಿರ್ಣಯಿಸುತ್ತದೆ.",

  // Form Fields
  "partner_1_details": "ಪಾರ್ಟ್ನರ್ 1 ವಿವರಗಳು",
  "partner_2_details": "ಪಾರ್ಟ್ನರ್ 2 ವಿವರಗಳು",
  "male_groom": "ಪುರುಷ/ವರ",
  "female_bride": "ಸ್ತ್ರೀ/ವಧು",
  "enter_groom_name": "ವರನ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
  "enter_bride_name": "ವಧುವಿನ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
  "full_name": "ಪೂರ್ಣ ಹೆಸರು",
  "gender": "ಲಿಂಗ",
  "male": "ಪುರುಷ",
  "female": "ಸ್ತ್ರೀ",
  "date_time_of_birth": "ಜನನ ದಿನಾಂಕ ಮತ್ತು ಸಮಯ",
  "place_of_birth": "ಜನ್ಮ ಸ್ಥಳ",
  "enter_partner_name": "ಪಾರ್ಟ್ನರ್ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
  "city_state_country": "ನಗರ, ರಾಜ್ಯ, ದೇಶ",
  "email_address": "ಇಮೇಲ್ ವಿಳಾಸ",
  "phone_number": "ಫೋನ್ ಸಂಖ್ಯೆ",
  "enter_email_for_report": "ವಿಸ್ತೃತ ವರದಿಗಾಗಿ ನಿಮ್ಮ ಇಮೇಲ್ ನಮೂದಿಸಿ",
  "enter_phone": "ನಿಮ್ಮ ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
  "contact_details_info": "ಸಂಪರ್ಕ ವಿವರಗಳನ್ನು ನೀಡುವುದರಿಂದ ನಿಮ್ಮ ಹೊಂದಾಣಿಕೆ ವರದಿ ನೇರವಾಗಿ ನಿಮಗೆ ತಲುಪುತ್ತದೆ.",
  "service_pricing": "ಸೇವಾ ಶುಲ್ಕ",
  "complete_horoscope_matching": "ಸಂಪೂರ್ಣ ಕುಂಡಲಿ ಮ್ಯಾಚಿಂಗ್ ವಿಶ್ಲೇಷಣೆ",
  "one_time_payment_info": "ನಿಪುಣ ಜ್ಯೋತಿಷಿಗಳಿಂದ ಸಂಪೂರ್ಣ ಮ್ಯಾಚಿಂಗ್ ವಿಶ್ಲೇಷಣೆಗೆ ಒಮ್ಮೆಲೆ ಪಾವತಿ",
  "detailed_compatibility_analysis": "ವಿಸ್ತೃತ ಹೊಂದಾಣಿಕೆ ವಿಶ್ಲೇಷಣೆ",
  "guna_milan_36_points": "ಗುಣ ಮಿಲಾನ್ (36 ಅಂಕಗಳ ವ್ಯವಸ್ಥೆ)",
  "manglik_dosha_analysis": "ಮಂಗಳ ದೋಷ ವಿಶ್ಲೇಷಣೆ",
  "future_predictions_couple": "ಜೋಡಿಗೆ ಭವಿಷ್ಯಭವಿಷ್ಯವಾಣಿ",
  "remedial_solutions": "ಪರಿಹಾರಗಳು ಮತ್ತು ಸಲಹೆಗಳು",
  "pdf_report_download": "PDF ವರದಿ ಡೌನ್‌ಲೋಡ್",
  "contact_information": "ಸಂಪರ್ಕ ಮಾಹಿತಿ",

  // Actions
  "match_horoscopes_now": "ಈಗಲೇ ಕುಂಡಲಿ ಮ್ಯಾಚ್ ಮಾಡಿ",
  "matching_horoscopes": "ಕುಂಡಲಿ ಮ್ಯಾಚಿಂಗ್ ನಡೆಯುತ್ತಿದೆ",
  "pay_and_match": "ಪಾವತಿಸಿ ಮತ್ತು ಕುಂಡಲಿ ಮ್ಯಾಚ್ ಮಾಡಿ",
  "processing_payment": "ಪಾವತಿ ಪ್ರಕ್ರಿಯೆ ನಡೆಯುತ್ತಿದೆ...",
  "dd_mm_yyyy_time_format": "DD/MM/YYYY ಮತ್ತು HH:MM (12-ಗಂಟೆ) AM/PM ರೂಪದಲ್ಲಿ ನಮೂದಿಸಿ",
  "am": "AM",
  "pm": "PM",
  "dd_placeholder": "DD",
  "mm_placeholder": "MM",
  "yyyy_placeholder": "YYYY",
  "hh_placeholder": "HH",

  // Results
  "compatibility_result": "ಹೊಂದಾಣಿಕೆ ಫಲಿತಾಂಶ",
  "overall_compatibility": "ಒಟ್ಟಾರೆ ಹೊಂದಾಣಿಕೆ",
  "guna_milan_points": "ಗುಣ ಮಿಲಾನ್ ಅಂಕಗಳು",
  "match_status": "ಮ್ಯಾಚ್ ಸ್ಥಿತಿ",
  "excellent_match": "ಅತ್ಯುತ್ತಮ ಮ್ಯಾಚ್",
  "good_match": "ಉತ್ತಮ ಮ್ಯಾಚ್",
  "average_match": "ಸರಾಸರಿ ಮ್ಯಾಚ್",
  "detailed_guna_analysis": "ವಿಸ್ತೃತ ಗುಣ ವಿಶ್ಲೇಷಣೆ",

  // Actions
  "download_detailed_report": "ವಿಸ್ತೃತ ವರದಿ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
  "consult_astrologer": "ಜ್ಯೋತಿಷಿಯನ್ನು ಸಂಪರ್ಕಿಸಿ",
  "match_another_couple": "ಇನ್ನೊಂದು ಜೋಡಿಯನ್ನು ಮ್ಯಾಚ್ ಮಾಡಿ",

  // Features
  "what_our_matching_includes": "ನಮ್ಮ ಮ್ಯಾಚಿಂಗ್‌ನಲ್ಲಿ ಏನು ಸೇರಿದೆ",
  "36_guna_analysis": "36 ಗುಣಗಳ ವಿಶ್ಲೇಷಣೆ",
  "36_guna_analysis_desc": "ಎಲ್ಲ 36 ಹೊಂದಾಣಿಕೆ ಅಂಶಗಳ ಸಂಪೂರ್ಣ ಮೌಲ್ಯಮಾಪನ",
  "love_compatibility": "ನಿಮ್ಮ ಪ್ರೇಮ ಜೀವನ",
  "love_compatibility_desc": "ಭಾವನಾತ್ಮಕ ಮತ್ತು ರೋಮ್ಯಾಂಟಿಕ್ ಸೌಹಾರ್ದತೆಯ ವಿಶ್ಲೇಷಣೆ",
  "family_harmony": "ಕುಟುಂಬ ಸೌಹಾರ್ದತೆ",
  "family_harmony_desc": "ದೀರ್ಘಕಾಲಿಕ ಸಂಬಂಧದ ಸ್ಥಿರತೆ ಬಗ್ಗೆ ಭವಿಷ್ಯವಾಣಿ",
  "manglik_dosha": "ಮಂಗಳ ದೋಷ ಪರಿಶೀಲನೆ",
  "manglik_dosha_desc": "ದೋಷಗಳ ಗುರುತುಗೊಳಿಕೆ ಮತ್ತು ಅವುಗಳ ಪರಿಹಾರಗಳು",

  // Thank You Message
  "thank_you_submission": "ನಿಮ್ಮ ಸಲ್ಲಿಕೆಗೆ ಧನ್ಯವಾದಗಳು!",
  "data_received_message": "ನಿಮ್ಮ ಕುಂಡಲಿ ಮ್ಯಾಚಿಂಗ್ ವಿನಂತಿಯನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಸ್ವೀಕರಿಸಲಾಗಿದೆ. наших ಅನುಭವಿ ಜ್ಯೋತಿಷಿಗಳು ಎರಡೂ ಕುಂಡಲಿಗಳನ್ನು ಜಾಗರೂಕತೆಯಿಂದ ವಿಶ್ಲೇಷಿಸುವರು.",

  // Security & Timeline
  "your_data_secure": "ನಿಮ್ಮ ಡೇಟಾ 100% ಸುರಕ್ಷಿತ",
  "data_security_message": "ಎಲ್ಲ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯೂ ಎನ್‌ಕ್ರಿಪ್ಟ್ ಆಗಿ ಸಂರಕ್ಷಿಸಲ್ಪಟ್ಟಿದೆ. ನಿಮ್ಮ ವಿವರಗಳನ್ನು ನಾವು ತೃತೀಯ ಪಕ್ಷಗಳೊಂದಿಗೆ ಹಂಚಿಕೊಳ್ಳುವುದಿಲ್ಲ.",
  "response_within_12_hours": "12 ಗಂಟೆಗಳ ಒಳಗೆ ಪ್ರತಿಕ್ರಿಯೆ",
  "response_time_message": "ನಮ್ಮ ನಿಪುಣರು ನಿಮ್ಮ ವಿಸ್ತೃತ ಹೊಂದಾಣಿಕೆ ವರದಿಯನ್ನು ಸಿದ್ಧಪಡಿಸಿ ಬೇಗನೇ ಸಂಪರ್ಕಿಸುವರು.",

  // Support
  "need_immediate_help": "ತಕ್ಷಣದ ಸಹಾಯ ಬೇಕೆ?",
  "whatsapp_support": "ವಾಟ್ಸಾಪ್ ಬೆಂಬಲ",
  "processing_request": "ನಿಮ್ಮ ವಿನಂತಿ ಪ್ರಕ್ರಿಯೆಯಲ್ಲಿದೆ",
  "back_to_home": "ಮುಖಪುಟಕ್ಕೆ ಹಿಂತಿರುಗಿ"
};

export default matchhoroscope;
